import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { Button, Field, Input, MessageBar, MessageBarBody } from "@fluentui/react-components";
import { AuthCard } from "../components/AuthCard.tsx";
import { useAuth } from "../lib/auth.tsx";

export function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: string } };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login({ email, password });
      nav(loc.state?.from ?? "/", { replace: true });
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Sign in" subtitle="Trainer access">
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {err && (
          <MessageBar intent="error">
            <MessageBarBody>{err}</MessageBarBody>
          </MessageBar>
        )}
        <Field label="Email" required>
          <Input type="email" autoComplete="email" value={email} onChange={(_, d) => setEmail(d.value)} />
        </Field>
        <Field label="Password" required>
          <Input type="password" autoComplete="current-password" value={password} onChange={(_, d) => setPassword(d.value)} />
        </Field>
        <Button appearance="primary" type="submit" disabled={busy}>
          Sign in
        </Button>
        <span>
          New trainer? <Link to="/register">Create an account</Link> · <Link to="/forgot-password">Forgot password?</Link>
        </span>
      </form>
    </AuthCard>
  );
}
